// Themes
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
};
